{
  "cancel": "Cancel",
  "delete": "Delete",
  "close": "Close",
  "done": "Done",
  "deleteTitle": "Delete record?",
  "deleteText": "Permanently delete this record?",
  "info": "Info",
  "objectInfoTitle": "Record information",
  "createdBy": "Created by",
  "createdAt": "Created on",
  "lastEditedBy": "Last edited by",
  "editedAt": "Edited on",
  "unknown": "Unknown",
  "system": "System",
  "objectHistoryTitle": "Record & history",
  "changes": "Changes",
  "loadingHistory": "Loading history…",
  "noHistory": "No change history yet.",
  "historyLoadError": "Could not load history.",
  "someone": "Someone",
  "historyDate": "Date",
  "historyUser": "User",
  "historyChange": "Change",
  "actionCreated": "created",
  "actionDeleted": "deleted",
  "actionChanged": "changed",
  "historyFallbackWithTitle": "“{{title}}” {{verb}}",
  "historyFallback": "Entry {{verb}}",
  "updateAvailable": "Update available",
  "updateBody": "A new version of this app is available.\nAn update is required for the best possible experience.",
  "updateLater": "Update later",
  "updateNow": "Update",
  "internetRequired": "(Internet required)",
  "releaseInfo": "Release notes",
  "selectMandant": "Select tenant",
  "noLicence": "No licence available",
  "noCompanyAssigned": "You are not assigned to any company.",
  "companiesLoadError": "Companies could not be loaded",
  "logout": "Sign out"
}
